import React, { FC } from 'react'

// Components
import { Modal } from 'components/shared'

// Styles
import { makeStyles, Theme, Box, IconButton, Typography, Grid } from '@material-ui/core'

// Images
import CloseIcon from '@material-ui/icons/Close'
import qrCode from '../../assets/sessions/qrcode.png'

interface QRCodeProps {
  qrCodeImage?: string
  url?: string
  showModal: boolean
  setShowModal: (boolean) => void
}

export const QRCode: FC<QRCodeProps> = ({
  qrCodeImage = '#',
  url = 'https://www.surveymonkey.com/r/5GFeb24',
  showModal,
  setShowModal
}) => {
  const classes = useStyles()

  return (
    <Modal open={showModal} onClose={() => setShowModal(false)} paperClasses={classes.paper}>
      <Box className={classes.root}>
        <div className={classes.container}>
          <IconButton
            className={classes.closeButton}
            color='default'
            aria-label='close'
            onClick={() => setShowModal(false)}
          >
            <CloseIcon fontSize='large' />
          </IconButton>
          <Grid container>
            <Grid item xs={12}>
              <Typography component='h1' variant='h4' className={classes.title} color='textPrimary' gutterBottom>
                5G Innovation Sessions
                <br />
                event survey.
              </Typography>
            </Grid>
            <Grid item container xs={12} spacing={3}>
              <Grid item xs={5}>
                <img src={qrCode} className={classes.qrCode} alt='QR Code for survey' />
              </Grid>
              <Grid item xs={7}>
                <Typography component='p' variant='body1' className={classes.modalDescription}>
                  To help us deliver the best 5G events for 2021 and beyond please complete the&nbsp;
                  <a href={url} target='_blank' rel='noreferrer'>
                    brief survey
                  </a>
                  . Your input helps us shape our events in the future. Thanks!
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '500px',
    borderRadius: 0,
    margin: '0 auto',
    position: 'relative',
    padding: '50px 40px 40px',
    backgroundColor: '#ffffff',
    overflow: 'auto',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '20px'
    }
  },
  paper: {
    [theme.breakpoints.down('sm')]: {
      height: 'auto !important'
    }
  },
  container: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 260,
      margin: '0 auto'
    }
  },
  title: {
    fontSize: 24
  },
  closeButton: {
    position: 'absolute',
    top: '0',
    right: '0'
  },
  qrCode: {
    width: '100%'
  },
  modalDescription: {
    color: '#000',
    '& a': {
      color: '#000'
    }
  }
}))
